// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3Ytq_","infoBtn":"quickbooks_infoBtn__1VtRw","formBox":"quickbooks_formBox__13k_B","formFooter":"quickbooks_formFooter__1PxvG"};